<template>
  <div class="index-box">
    <home></home>
  </div>
</template>
<script>
import Home from "./Home";
export default {
  components: {
    Home,
  },
};
</script>
